import {
  FileCategory,
  FlightCategory,
  isEditable,
  RequestStatus,
  DispatchStatuses,
} from 'src/constants';
import Title from './title.language';
import Label from './label.language';

export default {
  FILTER_WARNING_REQUIRED: {
    [isEditable.true]: 'Yes',
    [isEditable.false]: 'No',
  },

  REQUEST_TABLE_FILTER_LABEL: {
    requestorDistrict: 'District/Department/Project',
    requestStatus: 'Status',
    flightType: 'Flight Type',
    operatorName: 'Operator',
    tailNumber: 'Tail No',
    flightDate: 'Flight Date',
    tarStatus: 'TAR Status',
    requestorName: 'Requested By',
    fireAgency: 'Fire Agency',
  },

  FILE_CATEGORY: {
    [FileCategory.Admin]: 'Admin',
    [FileCategory.AirOpsPlan]: 'Air Ops Plan',
    [FileCategory.AirspaceAuthorization]: 'Airspace Authorization',
    [FileCategory.CampPendletonTAR]: 'Camp Pendleton TAR',
    [FileCategory.CongestedAreaPlan]: 'Congested Area Plan',
    [FileCategory.EnvironmentalCulturalRestrictions]:
      'Environmental/Cultural Restrictions',
    [FileCategory.FlightArea]: 'Flight Area',
    [FileCategory.LandManagementApproval]: 'Land Management Approval',
    [FileCategory.LandingZone]: 'Landing Zone',
    [FileCategory.LiftPlan]: 'Lift Plan',
    [FileCategory.PublicSafetyConcerns]: 'Public Safety Concerns',
    [FileCategory.SafetyMitigations]: 'Safety Mitigations',
    [FileCategory.SensitiveCustomer]: 'Sensitive Customer',
    [FileCategory.ShortHaulHEC]: 'Short Haul/HEC',
    [FileCategory.Special]: 'Special',
    [FileCategory.Structure]: 'Structure(s)',
  },

  FLIGHT_CATEGORY: {
    [FlightCategory.PatrolPassenger]:
      Title.TTL_REQUEST_PATROL_PASSENGER_CONTRACTOR,
    7: Title.TTL_REQUEST_PATROL_PASSENGER,
    [FlightCategory.ConstructionWork]: Title.TTL_REQUEST_CONSTRUCTION,
    [FlightCategory.ContractorConstruction]:
      Title.TTL_REQUEST_CONSTRUCTION_CONTRACTOR,
    [FlightCategory.DroneFlightInternal]: Title.TTL_DRONE_FLIGHT_SCG,
    [FlightCategory.DroneFlightExternal]: Title.TTL_DRONE_FLIGHT_CONTRACTOR,
  },

  REQUEST_STATUS: {
    [RequestStatus.PendingApproval]: 'Pending Approval',
    [RequestStatus.Cancelled]: 'Cancelled',
    [RequestStatus.Approved]: 'Approved',
    [RequestStatus.RequiresFlightCost]: 'Requires Cost',
    [RequestStatus.InFlight]: 'In-Flight',
    [RequestStatus.Completed]: 'Completed',
    [RequestStatus.Declined]: 'Declined',
  },

  FORM_VALIDATION: {},

  FORM_VALIDATION_Message: {
    flightAreaFiles: 'Upload a flight area file',
  },

  EMAIL_FIRE_DISPATCH_SUBJECT: {
    [DispatchStatuses.Cancelled]:
      'Notification of Firefighting Helicopter Dispatch Cancellation',
    [DispatchStatuses.Completed]:
      'Notification of Firefighting Helicopter Stats',
    [DispatchStatuses.Dispatched]:
      'Notification of Firefighting Helicopter Dispatch',
    [DispatchStatuses.InFlight]:
      'Notification of Firefighting Helicopter Launch',
    [DispatchStatuses.Landed]:
      'Notification of Firefighting Helicopter Landing',
  },

  RISK_DETAIL: {
    NA: 'Not Applicable',
    high: 'High',
    moderate: 'Moderate',
    low: 'Low',
  },

  FORM_LABEL: {
    requestorNo: Label.LBL_REQUEST_REQUESTOR_EMPLOYEE,
    requestorPhone: Label.LBL_REQUEST_REQUESTOR_CONTACT,
    fieldContactFlag: Label.LBL_REQUEST_FIELD_CONTACT,
    isEmployee: Label.LBL_REQUEST_FIELD_CONTACT_EMPLOYEE,
    fieldNo: Label.LBL_REQUEST_FIELD_CONTACT_NAME,
    fieldName: Label.LBL_REQUEST_FIELD_CONTACT_NAME,

    flightDate: Label.LBL_REQUEST_FLIGHT_DATE,
    startTime: Label.LBL_REQUEST_FLIGHT_START_TIME,
    flightDuration: Label.LBL_REQUEST_FLIGHT_DURATION,
    releaseTime: Label.LBL_REQUEST_FLIGHT_RELEASE_STANDBY_TIME,

    costCenter: Label.LBL_REQUEST_COST_CENTER,
    workOrder: Label.LBL_REQUEST_WORK_ORDER_NUMBER,
    ioNo: Label.LBL_REQUEST_IO_NUMBER,
    planCategory: Label.LBL_REQUEST_PLAN_CATEGORY,

    flightFlag: Label.LBL_FLIGHT_INFORMATION,

    // Contractor Contact
    primeEmail: Label.LBL_CONTRACTOR_EMAIL,

    // Patrol Passenger SDGE
    flightType: Label.LBL_FLIGHT_TYPE,
    flightDept: Label.LBL_FLIGHT_DISTRICT_DEPARTMENT,
    flightDestination: Label.LBL_FLIGHT_DESTINATION,
    flightLocation: Label.LBL_PICKUP_LOCATION,
    type: Label.LBL_TYPE,
    name: Label.LBL_PASSENGER_NAME,
    empNo: Label.LBL_PASSENGER_NAME,
    weight: Label.LBL_WEIGHT,

    pendletonFlag: Label.LBL_CAMP_PENDLETON_TAR,
    sensitiveFlag: Label.LBL_SENSITIVE_CUSTOMER,
    culturalFlag: Label.LBL_CULTURAL_RESTRICTION,
    helmetFlag: Label.LBL_HELMENT_SUIT,
    extraEquipmentFlag: Label.LBL_EXTRA_EQUIPMENT,
    hazmatFlag: Label.LBL_HAZMAT,
    basketFlag: Label.LBL_BASKET_REQUIRED,

    sensitiveFiles: Label.LBL_SENSITIVE_FILES,
    culturalFiles: Label.LBL_CULTURAL_RESTRICTION_FILES,

    basketWeight: Label.LBL_BASKET_WEIGHT,

    // Patrol Passenger Contractor
    project: Label.LBL_PROJECT_NAME,
    pickupLocation: Label.LBL_PICKUP_LOCATION,
    pipeline: Label.LBL_PIPELINE_NUMBER,
    coordinates: Label.LBL_COORINATES,

    tarFlag: Label.LBL_CAMP_PENDLETON_TAR,
    aomFlag: Label.LBL_AOM_REVIEW,
    asdTrackingFlag: Label.LBL_TRACKING_DEVICE,
    asdRadioFlag: Label.LBL_TWO_WAY_RADIO,

    primeContractor: Label.LBL_PRIME_CONTRACTOR,
    primeName: Label.LBL_CONTACT_NAME,
    primePhone: Label.LBL_CONTRACTOR_NUMBER,
    value: Label.LBL_PIPELINE_NUMBER,

    // Construction SDGE
    structureId: Label.LBL_STRUCTURE_ID,
    coordinate: Label.LBL_LANDING_ZONE_COORDINATE,
    equipmentFlag: Label.LBL_LONG_LINE,
    equipmentDescription: Label.LBL_DESCRIPTION,
    poleFlag: Label.LBL_POLE_SET,
    poleCount: Label.LBL_POLE_COUNT,
    ropeFlag: Label.LBL_SOCK_LINE_PULL,
    ropeSize: Label.LBL_ROPE_CONDUCTOR_SIZE,
    hecFlag: Label.LBL_SHORT_HAUL_HEC,
    crewCount: Label.LBL_CREW_PRESENT,
    crewFlag: Label.LBL_CREW_MOVEMENT,
    landingFlag: Label.LBL_REQUEST_HELP_LANDING_ZONE,
    loadWeight: Label.LBL_HEAVIEST_LOAD_WEIGHT,
    nightFlag: Label.LBL_NIGHT_FLIGHT,
    fileName: 'File Upload',
    flightAreaFiles: Label.LBL_FLIGHT_AREA,
    // Construction Contractor
    projectTitle: Label.LBL_PROJECT,
    airFlag: Label.LBL_AIR_OPS_PLAN,
    liftFlag: Label.LBL_LIFT_PLAN,
    complianceFlag: Label.LBL_SDGE_AOM_REVIEW_OPERATOR_COMPLIANCE,
    lineFlag: Label.LBL_LONG_LINE,
    sockFlag: Label.LBL_SOCK_LINE_PULL,
    platformFlag: Label.LBL_PLATFORM_WORK,
    skidFlag: Label.LBL_SKID_TRANSFER,
    aircraftType: Label.LBL_AIRCRAFT_TYPE,
    tailNo: Label.LBL_TAIL_NUMBER,

    // Drone SDGE
    address: Label.LBL_ADDRESS_CROSS_STREET,
    district: Label.LBL_FLIGHT_DISTRICT_DEPARTMENT,
    destination: Label.LBL_FLIGHT_DESTINATION,
    landFlag: Label.LBL_LAND_MANAGEMENT_APPROVAL_REQUIREMENT,
    landFiles: Label.LBL_LAND_MANAGEMENT_APPROVAL_REQUIREMENT_FILES,
    envFlag: Label.LBL_ENVIRONMENTAL_CONCERN,
    safetyFlag: Label.LBL_PUBLIC_SAFETY_CONCERNS,
    livestockFlag: Label.LBL_LIVESTOCK_CONCERNS,
    dnadeFlag: Label.LBL_NOTIFICATION_SENT,

    // Drone Contractor
    pilotName: Label.LBL_PILOT_IN_COMMAND,
    contractorName: Label.LBL_CONTRACTOR_NAME,
  },
};
